import CompilerEngine from '../compiler/CompilerEngine';
import { registerStandardBlocks } from '../compiler/StandardBlocks';
import { registerGenericDevice } from '../compiler/blocks/hardware/GenericDevice';
import { registerUltrasonicSensor } from '../compiler/blocks/hardware/UltrasonicSensor';
import { registerIRSensor } from '../compiler/blocks/hardware/IRSensor';
import { registerServoMotor } from '../compiler/blocks/hardware/ServoMotor';
import { registerLEDActuator } from '../compiler/blocks/hardware/LEDActuator';
import { registerPIRSensor } from '../compiler/blocks/hardware/PIRSensor';
import { registerDHTSensor } from '../compiler/blocks/hardware/DHTSensor';
import { registerBuzzerActuator } from '../compiler/blocks/hardware/BuzzerActuator';
import { registerDCMotor } from '../compiler/blocks/hardware/DCMotor';

// Ensure the standard blocks and hardware blocks are registered on boot
registerStandardBlocks();
registerGenericDevice();
registerUltrasonicSensor();
registerIRSensor();
registerServoMotor();
registerLEDActuator();
registerPIRSensor();
registerDHTSensor();
registerBuzzerActuator();
registerDCMotor();

class ArduinoGenerator {
    constructor() {
        this.reset();
    }

    reset() {
        // Kept for backward compatibility if called directly
    }

    /**
     * Main entry point.
     * @param {object} vm  scratch-vm instance
     * @returns {string}   C++ source ready for arduino-cli compilation
     */
    generate(vm) {
        return CompilerEngine.compile(vm);
    }
}

export default ArduinoGenerator;
